import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X } from "lucide-react";

const WHATSAPP_NUMBER = "919899463655";
const MESSAGE = encodeURIComponent(
  "Hello Haven & Hue, I'd like to enquire about a bespoke interior consultation."
);

export const WhatsAppFab = () => {
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 400);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0, scale: 0.6, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.6, y: 20 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          className="fixed bottom-6 left-6 z-50 flex items-end gap-3"
        >
          <AnimatePresence>
            {open && (
              <motion.a
                key="chip"
                href={`https://wa.me/${WHATSAPP_NUMBER}?text=${MESSAGE}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-chat-link"
                initial={{ opacity: 0, x: -12 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -12 }}
                className="mb-1 bg-[#1A1A1A] text-[#FAF9F6] px-5 py-3 text-sm tracking-wide hover:bg-[#C5A880] hover:text-[#1A1A1A] transition-colors duration-300 shadow-xl"
              >
                Chat with our studio
              </motion.a>
            )}
          </AnimatePresence>
          <button
            data-testid="whatsapp-fab"
            onClick={() => setOpen((v) => !v)}
            aria-label="WhatsApp chat"
            className="w-14 h-14 rounded-full bg-[#C5A880] text-[#1A1A1A] flex items-center justify-center shadow-xl hover:bg-[#1A1A1A] hover:text-[#C5A880] transition-colors duration-300"
          >
            {open ? <X size={22} /> : <MessageCircle size={24} />}
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
